import React from 'react';

const KallistoLogo = ({ width = 400, height = 120, className = "" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 120"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="primaryGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:"#FF8C00", stopOpacity:1}} />
          <stop offset="50%" style={{stopColor:"#FF4500", stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:"#B22222", stopOpacity:1}} />
        </linearGradient>
        <linearGradient id="accentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{stopColor:"#FFA07A", stopOpacity:0.8}} />
          <stop offset="100%" style={{stopColor:"#FF7F50", stopOpacity:0.3}} />
        </linearGradient>
      </defs>


      <g transform="translate(20, 20)">

        <g transform="translate(0, 0)">
          <circle cx="40" cy="40" r="35" fill="url(#primaryGradient)" opacity="0.9"/>


          <circle cx="40" cy="40" r="35" fill="none" stroke="url(#accentGradient)" strokeWidth="1" opacity="0.4"/> {/* Увеличен радиус */}


          <circle cx="35" cy="35" r="4" fill="#FFFFFF" opacity="0.3"/>
          <circle cx="48" cy="42" r="3" fill="#FFFFFF" opacity="0.2"/>
          <circle cx="38" cy="48" r="2" fill="#FFFFFF" opacity="0.25"/>


          <circle cx="65" cy="32" r="2" fill="url(#primaryGradient)" opacity="0.8"/>
          <circle cx="15" cy="48" r="1.5" fill="url(#primaryGradient)" opacity="0.6"/>


          <circle cx="70" cy="20" r="2" fill="url(#accentGradient)" opacity="0.7"/>
          <circle cx="75" cy="25" r="1.5" fill="url(#accentGradient)" opacity="0.5"/>
          <circle cx="72" cy="30" r="1" fill="url(#accentGradient)" opacity="0.3"/>
        </g>


        <g transform="translate(0, 0)">

          <text
            x="38"
            y="55"
            fontFamily="Arial, sans-serif"
            fontSize="45"
            fontWeight="700"
            fill="#FFFFFF"
            letterSpacing="-2px"
            textAnchor="end"
          >
            K
          </text>


          <text
            x="42"
            y="55"
            fontFamily="Arial, sans-serif"
            fontSize="45"
            fontWeight="700"
            fill="#FFFFFF"
            letterSpacing="-2px"
            textAnchor="start"
            opacity="0.9"
          >
            S
          </text>


          <text
            x="39"
            y="56"
            fontFamily="Arial, sans-serif"
            fontSize="45"
            fontWeight="700"
            fill="#000000"
            letterSpacing="-2px"
            textAnchor="end"
            opacity="0.1"
          >
            K
          </text>
          <text
            x="43"
            y="56"
            fontFamily="Arial, sans-serif"
            fontSize="45"
            fontWeight="700"
            fill="#000000"
            letterSpacing="-2px"
            textAnchor="start"
            opacity="0.1"
          >
            S
          </text>
        </g>
      </g>


      <g transform="translate(120, 35)">

        <text x="0" y="25" fontFamily="Arial, sans-serif" fontSize="32" fontWeight="600" fill="url(#primaryGradient)" letterSpacing="-1px">
          Kallisto
        </text>


        <text x="0" y="50" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="400" fill="#6B7280" letterSpacing="2px">
          SOFTWARE
        </text>


        <rect x="0" y="55" width="120" height="2" fill="url(#accentGradient)" rx="1"/>
      </g>


      <g opacity="0.1">
        <circle cx="350" cy="30" r="20" fill="none" stroke="#4F46E5" strokeWidth="1"/>
        <circle cx="350" cy="30" r="15" fill="none" stroke="#4F46E5" strokeWidth="1"/>
        <circle cx="350" cy="30" r="10" fill="none" stroke="#4F46E5" strokeWidth="1"/>
        <polygon points="345,25 355,25 350,35" fill="#4F46E5"/>
      </g>
    </svg>
  );
};

export default KallistoLogo;